import { useEffect } from 'react';

/**
 * Injects responsive <style> rules that work alongside mobile.css.
 * Targets the dynamic inline-style components that can't be
 * overridden with just a class name.
 */
export default function ResponsiveStyles() {
  useEffect(() => {
    const el = document.createElement('style');
    el.id = 'ef-responsive';
    el.textContent = `
      /* ── Stat grids ── */
      @media (max-width: 900px) {
        .stat-grid-4 { grid-template-columns: repeat(2,1fr) !important; }
      }
      @media (max-width: 480px) {
        .stat-grid-4 { grid-template-columns: 1fr !important; }
      }

      /* ── Two-column grids ── */
      @media (max-width: 768px) {
        .grid-2-col       { grid-template-columns: 1fr !important; }
        .admin-grid-2     { grid-template-columns: 1fr !important; }
        .withdraw-grid    { grid-template-columns: 1fr !important; }
        .payment-grid     { grid-template-columns: 1fr 1fr !important; }
        .platform-grid    { grid-template-columns: 1fr !important; }
        .settings-grid    { grid-template-columns: 1fr !important; }
      }

      /* ── Auth pages ── */
      @media (max-width: 768px) {
        .auth-split-left  { display: none !important; }
        .auth-split-right { padding: 32px 20px !important; }
      }

      /* ── Landing nav ── */
      @media (max-width: 768px) {
        .lp-nav-links { display: none !important; }
        .lp-hero-stats { gap: 24px !important; flex-wrap: wrap !important; }
        .lp-steps { grid-template-columns: 1fr !important; }
        .lp-platforms { grid-template-columns: repeat(2,1fr) !important; }
        .lp-testimonials { grid-template-columns: 1fr !important; }
        .lp-final-ctas { flex-direction: column !important; }
        .lp-final-ctas a { display: block !important; text-align: center !important; }
      }

      /* ── Tables ── */
      @media (max-width: 768px) {
        .table-responsive { overflow-x: auto !important; -webkit-overflow-scrolling: touch; }
        .table-responsive table { min-width: 600px; }
      }

      /* ── Dashboard inner padding ── */
      @media (max-width: 768px) {
        .dash-inner-wrap { padding: 18px 14px !important; }
      }

      /* ── Page headers ── */
      @media (max-width: 768px) {
        .page-header { flex-direction: column !important; align-items: flex-start !important; }
        .page-header .header-actions { width: 100% !important; }
        .page-header .header-actions > * { flex: 1 !important; justify-content: center !important; text-align: center !important; }
      }

      /* ── Modal ── */
      @media (max-width: 540px) {
        .ef-modal {
          position: fixed !important;
          bottom: 0 !important; left: 0 !important; right: 0 !important;
          border-radius: 20px 20px 0 0 !important;
          max-width: 100% !important;
          max-height: 90vh !important;
          overflow-y: auto !important;
          margin: 0 !important;
        }
        .ef-modal-overlay {
          align-items: flex-end !important;
          padding: 0 !important;
        }
      }

      /* ── Admin stat grid ── */
      @media (max-width: 900px) {
        .admin-stat-grid { grid-template-columns: repeat(2,1fr) !important; }
      }
      @media (max-width: 480px) {
        .admin-stat-grid { grid-template-columns: 1fr !important; }
      }

      /* ── Withdraw page ── */
      @media (max-width: 768px) {
        .withdraw-layout { grid-template-columns: 1fr !important; }
      }

      /* ── Touch targets ── */
      button, a { min-height: 36px; }

      /* ── Prevent font zoom on iOS ── */
      input, select, textarea { font-size: 16px !important; }

      /* ── Smooth scrolling ── */
      html { scroll-behavior: smooth; }

      /* ── Hide scrollbar on mobile sidebar ── */
      .mobile-sidebar::-webkit-scrollbar { display: none; }
      .mobile-sidebar { -ms-overflow-style: none; scrollbar-width: none; }
    `;
    document.head.appendChild(el);
    return () => {
      const existing = document.getElementById('ef-responsive');
      if (existing) document.head.removeChild(existing);
    };
  }, []);

  return null;
}
